// Monto de una línea del detalle de un DTE, redondeado a peso.
//
// Es la única fuente de verdad de los montos: el Detalle del DTE, los Totales
// del encabezado y el panel de totales de la vista deben salir todos de acá. Si
// divergen, el documento queda descuadrado contra sí mismo y el SII lo rechaza
// después de haber consumido un folio. El backend valida esta misma igualdad
// en submitJsonDte, así que un descuadre acá se traduce en un 400.
export const calcularLinea = (producto) => {
  const cantidad = parseInt(producto.cantidad || 0, 10);
  const precio = parseFloat(producto.precio || 0);
  const descuento = parseFloat(producto.descuento || 0);
  const bruto = Math.round(cantidad * precio);
  const montoDescuento = Math.round(bruto * (descuento / 100));
  return { cantidad, precio, descuento, montoDescuento, monto: bruto - montoDescuento };
};

export const sumarLineas = (productos) =>
  productos.reduce((acc, producto) => acc + calcularLinea(producto).monto, 0);
